// Permitir usar API local ou de produção
const API_URL = process.env.REACT_APP_API_URL || 'https://api.hybrx.cloud/api';

export const api = {
  async getProducts(): Promise<any[]> {
    const response = await fetch(`${API_URL}/products`);
    if (!response.ok) {
      throw new Error('Erro ao buscar produtos');
    }
    return response.json();
  },

  async getAllProducts(params?: {
    search?: string;
    orderBy?: string;
    orderDirection?: 'ASC' | 'DESC';
    page?: number;
    size_items?: number;
  }): Promise<{
    products: any[];
    pagination: {
      total: number;
      page: number;
      size_items: number;
      total_pages: number;
    };
  }> {
    const queryParams = new URLSearchParams();
    
    if (params?.search) {
      queryParams.append('search', params.search);
    }
    if (params?.orderBy) {
      queryParams.append('orderBy', params.orderBy);
    }
    if (params?.orderDirection) {
      queryParams.append('orderDirection', params.orderDirection);
    }
    if (params?.page) {
      queryParams.append('page', params.page.toString());
    }
    if (params?.size_items) {
      queryParams.append('size_items', params.size_items.toString());
    }

    const queryString = queryParams.toString();
    const url = `${API_URL}/all_products${queryString ? `?${queryString}` : ''}`;
    
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error('Erro ao buscar produtos');
    }
    
    const data = await response.json();
    
    // Compatibilidade: se a API retornar array direto (produção antiga), converter para formato esperado
    if (Array.isArray(data)) {
      let filteredProducts = [...data];
      
      // Normalizar campos de data (createdAt/updatedAt -> created_at/updated_at)
      filteredProducts = filteredProducts.map((product: any) => ({
        ...product,
        created_at: product.created_at || product.createdAt,
        updated_at: product.updated_at || product.updatedAt
      }));
      
      // Aplicar busca localmente se necessário
      if (params?.search) {
        const searchTerm = params.search.toLowerCase();
        filteredProducts = filteredProducts.filter((product: any) => {
          const nome = (product.nome || '').toLowerCase();
          const nome_responsavel = (product.nome_responsavel || '').toLowerCase();
          const telefone_responsavel = (product.telefone_responsavel || '').toLowerCase();
          return nome.includes(searchTerm) || 
                 nome_responsavel.includes(searchTerm) || 
                 telefone_responsavel.includes(searchTerm);
        });
      }
      
      // Aplicar ordenação localmente
      if (params?.orderBy) {
        const orderBy = params.orderBy;
        const orderDirection = params.orderDirection || 'ASC';
        
        filteredProducts.sort((a: any, b: any) => {
          let aValue = a[orderBy];
          let bValue = b[orderBy];
          
          // Tratar valores nulos
          if (aValue === null || aValue === undefined) aValue = '';
          if (bValue === null || bValue === undefined) bValue = '';
          
          // Converter para string para comparação
          const aStr = String(aValue).toLowerCase();
          const bStr = String(bValue).toLowerCase();
          
          let comparison = 0;
          if (aStr > bStr) comparison = 1;
          else if (aStr < bStr) comparison = -1;
          
          return orderDirection === 'DESC' ? -comparison : comparison;
        });
      }
      
      const total = filteredProducts.length;
      const page = params?.page || 1;
      const size_items = params?.size_items || 10;
      
      // Aplicar paginação manualmente
      const startIndex = (page - 1) * size_items;
      const endIndex = startIndex + size_items;
      const paginatedProducts = filteredProducts.slice(startIndex, endIndex);
      
      return {
        products: paginatedProducts,
        pagination: {
          total,
          page,
          size_items,
          total_pages: Math.ceil(total / size_items)
        }
      };
    }
    
    // Se já estiver no formato correto (produção atualizada/local), normalizar campos de data
    if (data.products && Array.isArray(data.products)) {
      data.products = data.products.map((product: any) => ({
        ...product,
        created_at: product.created_at || product.createdAt,
        updated_at: product.updated_at || product.updatedAt
      }));
    }
    
    return data;
  },

  async updateProduct(id: number, data: { nome_responsavel: string; telefone_responsavel: string }): Promise<any> {
    const response = await fetch(`${API_URL}/products/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Erro ao atualizar produto');
    }
    return response.json();
  },
};
